import React from 'react'
import parse from 'html-react-parser'
import Figure from './Figure'
import { FragmentProps } from '../../../interfaces/Publication'
import { usePublication } from '../../../hooks/usePublication'


const EDITORIAL = ({ fragment }: FragmentProps) => {

    const { path } = usePublication()

    return (
        <article id="s3" className="article" data-scrollspy="">



            <div className="grid">
                <div className="grid__cell">
                    <figure className="bq-cite">
                        {fragment.img ? (<img className="bq-cite__img" src={`${path}images/${fragment.img}`} alt="" />) : null}
                        {fragment.autor ? (<blockquote>{parse(fragment.autor || '')}</blockquote>) : null}
                    </figure>
                </div>
            </div>

            {
                fragment.urlObj ?
                    <div className="header__actions">
                        <a className="btn btn-alt-primary" href={fragment.urlObj} target='_blank'>
                            <span className="btn__icon"><i className="icon icon-vpro-sec-tech-sheet"></i></span>
                            <span className="btn__label">Ver ficha técnica</span>
                        </a>
                    </div>
                    : null
            }

            {fragment.title ? (<h3>{fragment.title}</h3>) : null}
            {
                fragment.subtitle ?
                    <h4 style={{ display: 'block', paddingBottom: '20px', borderBottom: '.1rem solid var(--border-color)' }}>{fragment.subtitle}</h4>
                    : null
            }

            <div className="grid ">
                <div className="grid__cell">
                    <>
                        {fragment.text ? parse(fragment.text) : null}
                    </>
                </div>
                {/* <div className="grid__cell">
                    <>
                        {fragment.text2 ? parse(fragment.text2) : null}
                    </>
                </div> */}
            </div>
        </article>

    )
}

export default EDITORIAL
